import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NonSupervisorRoute = ({ children }) => {
    const { userRole } = useAuth();

    if (userRole === 'Supervisor') {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default NonSupervisorRoute;
